var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHuobiSmallIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 15,
    viewBox: "0 0 9 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.44907 5.15559C6.27174 7.1677 4.27083 8.98822 3.59443 10.138C2.94582 11.2406 2.71988 12.2827 3.19434 14.2954C3.21953 14.4022 3.11305 14.4956 3.01371 14.4498C2.16606 14.059 0.00878906 12.8868 0.00878906 10.0922C0.00878906 6.15023 4.35006 6.00942 4.14604 0.674211C4.14194 0.566965 4.25875 0.494076 4.34612 0.555862C5.76638 1.56024 6.61812 3.23771 6.44907 5.15559Z",
    fill: "#0CA28B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.3261 14.3158C3.27746 14.3005 3.24353 14.2547 3.24161 14.2022C3.19442 12.9177 3.86348 12.0782 4.61369 11.4554C6.2789 10.0731 7.30561 8.20627 6.89931 6.04625C6.87501 5.91739 7.02121 5.83235 7.10291 5.93292C7.49461 6.4153 7.89361 7.06903 8.11441 7.5456C9.17951 9.90911 8.61111 12.6177 6.06245 13.9845C5.26453 14.3937 4.31703 14.6286 3.3261 14.3158Z",
    fill: "#3BBEAA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHuobiSmallIcon);
export default __webpack_public_path__ + "static/media/huobiSmallIcon.1cf7859b76d65f6e694752b6d607fe7a.svg";
export { ForwardRef as ReactComponent };